<template>
    <el-dialog class="dialog-box" title="报表属性设置" v-if="outerForm" :visible.sync="outerForm" width="50vw" top="5vh">
        <el-form :model="dialogForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="看板名称" >
                <el-input size="small" v-model="dialogForm.name" placeholder="输入看板名称" ></el-input>
            </el-form-item>

            <el-form-item label="报表说明">
                <markdown-editor ref="markdownEditor" v-model="dialogForm.popovertext" mode="wysiwyg" language="zh-CN" height="200px" />
            </el-form-item>

            <el-form-item class="container" label="选项卡名称" v-if="dialogForm.tabs && dialogForm.tabs.length>0">
                <el-input class="item" size="small" v-model="tab.name" v-for="(tab,index) in dialogForm.tabs" :key="index"></el-input>
            </el-form-item>

            <el-form-item label="视图宽度">
                <el-radio-group v-model="dialogForm.width">
                    <el-radio :label="6">1/4</el-radio>
                    <el-radio :label="8">1/3</el-radio>
                    <el-radio :label="12">1/2</el-radio>
                    <el-radio :label="24">1/1</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="视图高度">
                <el-input size="small" v-model="dialogForm.height" style="width:100px"></el-input> px
            </el-form-item>
        </el-form>

         <div class="dialog-butn-box" style="margin: 0 20px 10px">
            <el-button size="small" type="primary" :loading="saveLoding" @click="handleSave">确定</el-button>
            <el-button  size="small" @click="outerForm=false">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import MarkdownEditor from '@/components/MarkdownEditor'
import {ajax_updateView} from '@Bdc~/api/ajax_model'
export default {
    components:{MarkdownEditor},
    data() {
        return {
            outerForm: false,
            dialogForm:{
                name:'',
                popovertext:'',
                tabs:[],
                width:'',
                height:''
            },
            rules:{},
            saveLoding:false
        }
    },

    methods: {
        // 初始化
        init(data) {
            this.dialogForm = JSON.parse(JSON.stringify(data))
            this.transferData(this.dialogForm, this.dialogForm)
            this.dialogForm.height = data.height.substring(0, data.height.indexOf('p'))
            this.outerForm = true
            this.saveLoding = false
        },

        // 递归转换数据
        transferData(list,parent) {
            if(list.kpiId == -1) {
                if(list.childs && list.childs.length > 0) {
                    list.childs.forEach(item => {
                      this.transferData(item,parent)      
                    });
                }
            }

            if(list.kpiId == -2) {
                this.$set(parent,'tabs',[])
                if(list.childs && list.childs.length > 0) {
                    list.childs.forEach(item => {
                        parent.tabs.push(item)
                        // console.log(item, parent)
                    });
                }
            }
        },

        // 确定
        handleSave() {
            this.saveLoding = true
            const data = {
                id: this.dialogForm.id,
                name: this.dialogForm.name,
                sort: this.dialogForm.sort,
                height: this.dialogForm.height + 'px',
                popovertext: this.dialogForm.popovertext,
                width: this.dialogForm.width,
                tabs: this.dialogForm.tabs || []
            }
            // console.log('修改的内容：',data)
            ajax_updateView(data).then(response => {
                this.saveLoding = false
                if(response.code == 1) {
                   this.outerForm = false
                   this.$emit('recoverList') 
                }
            })

        },
    }
}
</script>

<style lang="scss" scoped>
    .dialog-box {
        ::v-deep .el-dialog__body{
            padding: 20px 60px 20px 20px;
        }

        .container{
            ::v-deep.el-form-item__content{
                display: flex;
                flex-flow: row wrap;
            }
            .item{
                width: 120px;
                flex-flow: 1;
                margin-right: 10px;
                
            }
        }
    }
</style>